export default "__VITE_ASSET__BTfB_Jhn__"